<template>
  <div class="content">
    <ul class="flex">
      <li @click="jump('futureEasy')">
        <img src="../../assets/index/index1.png">
        <span>目标定制</span>
      </li>
      <li @click="jump('/aiList',true)">
        <img src="../../assets/index/index2.png">
        <span>智能AI填报</span>
      </li>
      <li @click="jump('/specialtyList')">
        <img src="../../assets/index/index3.png">
        <span>看专业</span>
      </li>
      <li @click="jump('/schoolList')">
        <img src="../../assets/index/index4.png">
        <span>看学校</span>
      </li>
      <li @click="jump('/artificialList?type=self',true)">
        <img src="../../assets/index/index5.png">
        <span>志愿测评</span>
      </li>
      <li @click="jump('/mbti')">
        <img src="../../assets/index/index7.png">
        <span>性格测试</span>
      </li>
      <li @click="jump('/yifenyiduan')">
        <img src="../../assets/index/index6.png">
        <span>历年数据</span>
      </li>

    </ul>
  </div>
</template>

<script>
  import {
    jump
  } from '../../../static/function.js'
  export default {
    data() {
      return {

      }
    },
    created() {

    },
    methods: {
      jump_path(path, number) {
        this.path_to = path
        localStorage.setItem('activeurl', path)
        this.$router.push({
          path: path
        })
      },
    }
  }
</script>

<style scoped>
  .flex {
    justify-content: space-between;
  }

  .flex li {
    width: 140px;
    list-style: none;
    text-align: center;
  }

  img {
    width: 74px;
    height: 74px;
    display: block;
    margin: 40px auto;
  }

  .content {
    width: 1280px;
    height: 198px;
    background: #FFFFFF;
    margin: 15px auto;
    box-shadow: 0px 1px 29px 1px rgba(0, 0, 0, 0.03);
  }
</style>



// WEBPACK FOOTER //
// src/components/index/functions.vue